import { shallowEqual, useSelector } from 'react-redux';

const useCurrentOffer = () => {
  const currentOffer = useSelector(state => state.offers.currentOffer, shallowEqual);
  return currentOffer;
};

export default useCurrentOffer;
